import { createContext, useContext } from "react";
import { GovFieldContentType, GovFieldProps } from "@publicMirage/components/govReact/GovField";
import { IPrePpWlForm, IPrePpWlFormField } from "@shared/prePublicPortalWestLindsay/contracts/IPrePpWlForm";

const FormContext = createContext({} as FormContext);

export function useForm() {
    return useContext(FormContext);
}

export function FormProvider({ children, value }: { children: React.ReactNode; value: FormContext }) {
    return <FormContext.Provider value={value}>{children}</FormContext.Provider>;
}

interface FormContext {
    formState: IPrePpWlForm;
    setFormState: React.Dispatch<React.SetStateAction<IPrePpWlForm>>;
    toFieldProps: (fieldName: keyof IPrePpWlForm, contentType: GovFieldContentType, radioValue?: string) => GovFieldProps;
    setFieldValue: (fieldName: keyof IPrePpWlForm, value: any) => void;
    getFieldProp: <FieldName extends keyof IPrePpWlForm, Prop extends keyof IPrePpWlFormField<IPrePpWlForm[FieldName]>>(
        fieldName: FieldName,
        prop: Prop
    ) => IPrePpWlFormField[Prop];
    previous: () => void;
}
